import { useNavigate } from "react-router-dom";
import { Lock, X } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function LockModal({ open, onClose }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
      data-testid="lock-modal"
    >
      <div
        className="relative w-full max-w-md bg-[#0A0A0A] border border-nhgreen/30 rounded-2xl p-8 shadow-[0_0_40px_rgba(34,255,119,0.15)] nh-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          data-testid="lock-modal-close"
          className="absolute top-4 right-4 text-white/40 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="w-14 h-14 rounded-full bg-nhgreen/10 border border-nhgreen/30 flex items-center justify-center mb-5">
          <Lock className="w-6 h-6 text-nhgreen" />
        </div>
        <h3 className="font-mono font-bold text-xl text-white">{t("locked_title")}</h3>
        <p className="text-white/60 text-sm mt-3 leading-relaxed">{t("locked_msg")}</p>
        <div className="flex flex-col sm:flex-row gap-3 mt-7">
          <button
            data-testid="lock-modal-register"
            onClick={() => navigate("/register")}
            className="flex-1 font-mono font-bold text-sm bg-nhgreen text-black rounded-md py-3 hover:bg-[#1ee068] hover:shadow-[0_0_15px_rgba(34,255,119,0.4)] transition-[background-color,box-shadow] duration-200"
          >
            {t("register_first")}
          </button>
          <button
            data-testid="lock-modal-login"
            onClick={() => navigate("/login")}
            className="flex-1 font-mono font-bold text-sm bg-transparent border border-white/20 text-white rounded-md py-3 hover:border-nhgreen hover:text-nhgreen transition-colors duration-200"
          >
            {t("login_first")}
          </button>
        </div>
      </div>
    </div>
  );
}
